import * as React from 'react';
import { faFire } from '@fortawesome/pro-solid-svg-icons/faFire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    className?: string;
    savedCount: number;
    showSavedCount: boolean;
};

const ItemSaveButton = ({ className, savedCount = 0, showSavedCount = false }: Props) => {
    const showCount = showSavedCount && savedCount > 0;
    const countMessageId = showCount && savedCount > 1 ? 'bidders_saved_item' : 'bidder_saved_item';

    if (showCount) {
        return (
            <LiveItemSaveDiv className={className}>
                <MessageWrapperText colorPrimaryWeak primary>
                    {savedCount >= 15 && <FireFontAwesomeIcon icon={faFire} />}
                    <FormattedMessage id={countMessageId} values={{ savedCount }} />
                </MessageWrapperText>
            </LiveItemSaveDiv>
        );
    }

    return null;
};

export default ItemSaveButton;

const MessageWrapperText = styled(Text)`
    && {
        font-size: 13px;
        margin-top: 10px;
        text-align: center;
    }
`;

const FireFontAwesomeIcon = styled(FontAwesomeIcon)`
    color: ${({ theme }) => theme.colors.red100};
    margin-right: 4px;
`;

const LiveItemSaveDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

LiveItemSaveDiv.displayName = 'LiveItemSaveDiv';
